import * as Yup from 'yup'

export const roundsValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required'),
  start_date: Yup.string().required('start date is required')
});